import { createFetcher } from '@composables/createFetcher';

type CommentGetPayload = {
  contentId?: string;
  replyToId?: string;
};

type CommentPostPayload = {
  contentId?: string;
  comment?: string;
  replyToId?: string;
};

type CommentPatchPayload = {
  commentId: string;
  comment: string;
};

type CommentLikePayload = {
  commentId: string;
};

type CommentReportPayload = {
  commentId: string;
  reason: string;
};

export const useCommentFetcher = () => {
  const getFetcher = createFetcher<CommentGetPayload>({
    endpoint: '/comment',
    method: 'GET',
    requiresAuth: true,
    payloadAsQuery: true,
  });

  const postFetcher = createFetcher<CommentPostPayload>({
    endpoint: '/comment',
    method: 'POST',
    requiresAuth: true,
    requiresArtistId: true,
  });

  const patchFetcher = createFetcher<CommentPatchPayload>({
    endpoint: '/comment',
    method: 'PATCH',
    requiresAuth: true,
  });

  const likeFetcher = createFetcher<CommentLikePayload>({
    endpoint: '/comment/like',
    method: 'POST',
    requiresAuth: true,
  });

  const deleteLikeFetcher = createFetcher<CommentLikePayload>({
    endpoint: '/comment/like',
    method: 'DELETE',
    requiresAuth: true,
    payloadAsQuery: true,
  });

  const reportFetcher = createFetcher<CommentReportPayload>({
    endpoint: '/comment/report',
    method: 'POST',
    requiresAuth: true,
  });

  return {
    fetch: {
      data: getFetcher.data,
      error: getFetcher.error,
      isFetching: getFetcher.isFetching,
      fetchComments: getFetcher.execute,
    },
    post: {
      data: postFetcher.data,
      error: postFetcher.error,
      isFetching: postFetcher.isFetching,
      postComment: postFetcher.execute,
    },
    patch: {
      data: patchFetcher.data,
      error: patchFetcher.error,
      isFetching: patchFetcher.isFetching,
      patchComment: patchFetcher.execute,
    },
    like: {
      data: likeFetcher.data,
      error: likeFetcher.error,
      isFetching: likeFetcher.isFetching,
      likeComment: likeFetcher.execute,
    },
    deleteLike: {
      data: deleteLikeFetcher.data,
      error: deleteLikeFetcher.error,
      isFetching: deleteLikeFetcher.isFetching,
      deleteLikeComment: deleteLikeFetcher.execute,
    },
    report: {
      data: reportFetcher.data,
      error: reportFetcher.error,
      isFetching: reportFetcher.isFetching,
      reportComment: reportFetcher.execute,
    },
  };
};
